import _ from 'lodash'
import React from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames/bind'
import Carousel from '../../../layouts/carousel'
import Modal from '../../../overlays/modal'
import Text from '../../../elementals/text'
import Icon from '../../../elementals/icon'
import styles from './styles.scss'
const cx = classnames.bind(styles)

const settings = {
  dots: true,
  infinite: true,
  speed: 500,
  adaptiveHeight: true,
  slidesToShow: 1,
  slidesToScroll: 1,
  fade: false,
  lazyLoad: false,
  variableWidth: false,
  autoplay: false,
  _rows: 2,
  _slidesPerRow: 2,
}

const closeIcon = (
  <Icon
    className='close'
    name='times'
    iconStyle='regular'
    color='gray'
    fitted
  />
)

const PhotoCarouselModal = props => {
  const {
    photos,
    isOpen,
    onClose,
    address = '',
    photoId = '',
    source = '',
  } = props
  const startPhoto = _.find(photos, { value: photoId }) || {}
  const photosToDisplay = _.filter(photos, {
    isSelected: startPhoto.isSelected,
  })
  const initialIndex = photosToDisplay.indexOf(startPhoto)
  return (
    <Modal
      open={isOpen}
      onClose={onClose}
      className={cx('carousel-modal')}
      closeIcon={closeIcon}
    >
      <Text className='u-pb-1' size='large' weight='heavy'>
        <Icon name='images' size='big' iconStyle='solid' />
        {`${source} Photos`}
      </Text>
      <Text className='u-pb-1' size='large' weight='medium'>
        {address}
      </Text>
      <Carousel
        alwaysShowArrows
        settings={{ ...settings, initialSlide: initialIndex }}
        elmId='property_carousel'
      >
        {photosToDisplay.map((photo, i) => (
          <img key={i} height='100%' width='100%' src={photo.photoUrl} />
        ))}
      </Carousel>
    </Modal>
  )
}

PhotoCarouselModal.propTypes = {
  photos: PropTypes.array.isRequired,
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  address: PropTypes.string,
  photoId: PropTypes.string,
  source: PropTypes.string,
}

export default PhotoCarouselModal
